module.exports = __webpack_public_path__ + "static/media/clearTable.7f54395a.png";